export default __webpack_public_path__ + "static/media/more.6ba2d8ab.svg";